import { useTranslate } from '../../lib'
import { TextareaNesting } from '../common/Inputs/Input'
import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import ButtonYesNo from '../common/ButtonYesNo'

export default function WizardStep5({ 
  formData, 
  setFormData, 
  refs, 
  campaings, 
  subCampaings,
  avatarPreview,
  setAvatarPreview,
  setAvatarFile
}) {
  const { t } = useTranslate();

  const validateImageFile = (file) => {
    const allowed = ['image/jpeg', 'image/png']
    if (!allowed.includes(file.type)) return { ok: false, message: 'Only JPG and PNG are allowed' }
    if (file.size > 100 * 1024) return { ok: false, message: 'Max file size is 100KB' }
    return { ok: true }
  }

  const handleAvatarChange = (e) => {
    const file = e.target.files[0]
    if (!file) return
    const valid = validateImageFile(file)
    if (!valid.ok) {
      e.target.value = null
      return
    }

    const img = new Image()
    const url = URL.createObjectURL(file)
    img.onload = () => {
      if (img.width > 200 || img.height > 200) {
        URL.revokeObjectURL(url)
        return
      }
      setAvatarPreview(url)
      setAvatarFile(file)
    }
    img.onerror = () => {
      URL.revokeObjectURL(url)
    }
    img.src = url
  }

  return (
    <div className="wizard-step">
      <h2 className="mb-4" style={{ color: '#0B5FA3', fontSize: 20 }}>
        {t('menu.genai.callSettings')}
      </h2>

      <div className="p-0-mb flex flex-col flex-1 mt-2" style={{ paddingRight: 20, paddingLeft: 20 }}>
        <div className="inputs" style={{ marginTop: 25 }}>
          <div className="input d-flex flex-row align-items-center" style={{ alignItems: "center", flexDirection: "row" }}>
            <span>{t('menu.genai.interactionType')}:</span>
            <div className="list_call_type ml-2 d-flex flex-row align-items-center">
              <ButtonYesNo
                onClick={() => setFormData({ ...formData, category: formData.category === "outbound" ? "inbound" : "outbound" })}
                width={170}
                state={formData.category === "outbound" ? false : true}
                height={30}
                Yes={t('common.inbound')}
                No={t('common.outbound')}
              />
            </div>
          </div>
        </div>

        {formData.category === 'outbound' && <TextareaNesting
          containerClass="mr-2 mt-3"
          ref={refs.welcome_mesage_ref}
          id="welcome_mesage"
          type="text"
          row={4}
          title={`${t('menu.genai.outboundCallMessage')}:`}
          boxInfo={true}
          tooltipText={t('menu.genai.outboundCallMessageTooltip')}
          onChange={(e) => setFormData({ ...formData, outbound_call_message: e.target.value })} 
          defaultValue={formData.outbound_call_message}
        />}

        <div className="inputs" style={{ marginTop: 20 }}>
          <div className="input" id="selectbox">
            <div className="d-flex flex-row align-items-center justify-space-between w-100">
              <span>{t('common.campaign')}:</span>
              <img id="campaign-tp" src="/icons/tooltip-indicator-icon.svg" className="ml-1 cursor-pointer tooltip-nesting" alt="" />
              <Tooltip openOnClick={true} anchorSelect="#campaign-tp" html={t('menu.genai.campaignTooltip')} place="top" />
              <select ref={refs.campaign_ref} className='select ml-5 select-nesting input-data'
                style={{ flexGrow: '2', backgroundPositionX: "96%", height: "100%" }}
                onChange={(e) => setFormData({ ...formData, campaign_id: e.target.value })} 
                defaultValue={formData.campaign_id}>
                <option disabled selected>
                  {t('menu.genai.campaignForProject')}
                </option>
                {campaings.map((item, i) => (
                  <option value={item.id} key={item.id}>{item.name}</option>
                ))}
              </select>
            </div>
          </div>
        </div>

        <div id='con-subcampaign' className="inputs" style={{ marginTop: 20 }}>
          <div className="input" id="selectbox">
            <div className="d-flex flex-row align-items-center justify-space-between w-100">
              <span>{t('common.subCampaign')}:</span>
              <img id="subcampaign-tp" src="/icons/tooltip-indicator-icon.svg" className="ml-1 cursor-pointer tooltip-nesting" alt="" />
              <Tooltip openOnClick={true} anchorSelect="#subcampaign-tp" html={`Select the subcampaign for the project`} place="top" />
              <select ref={refs.subcampaing_ref} className='select ml-1 select-nesting input-data'
                style={{ flexGrow: '2', backgroundPositionX: "96%", height: "100%" }}
                onChange={(e) => setFormData({ ...formData, sub_campaign_id: e.target.value })} 
                defaultValue={formData.sub_campaign_id}>
                <option disabled selected>
                  {t('menu.genai.subcampaignForProject')}
                </option>
                {subCampaings.map((item, i) => (
                  <option value={item.id} key={item.id}>{item.name}</option>
                ))}
              </select>
            </div>
          </div>
        </div>

        <div className='d-flex flex-row flex-wrap mt-1 align-center'>
            <div className="inputs">
              <div className="input">
                <div className='d-flex flex-col w-100 mr-3' style={{ alignItems: "center", flexDirection: "row" }}>
                  <span>{t('menu.genai.minimumPassingScore')}:</span>
                  <img id="min-score" src="/icons/tooltip-indicator-icon.svg" className="ml-1 cursor-pointer tooltip-nesting" alt="" />
                  <Tooltip openOnClick={true} anchorSelect="#min-score"
                    html={t('menu.genai.minimumPassingScoreTooltip')} place="top" />
                  <input
                    ref={refs.minimum_passing_score_ref}
                    defaultValue={formData.minimum_passing_score}
                    onChange={(e) => setFormData({ ...formData, minimum_passing_score: e.target.value })}
                    type="number"
                    min="1"
                    max="100"
                    className="input-text input-data ml-2"
                    style={{ maxWidth: 90 }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 0 }} className='mt-2'>
            <label style={{ fontSize: 14, color: '#2E2E2E', fontWeight: 700, minWidth: 60 }}>Avatar:</label>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ width: 50, height: 50, border: '1px solid #ddd', borderRadius: 6, overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fff' }}>
                  {avatarPreview ? <img src={avatarPreview} alt="avatar" style={{ maxWidth: '100%', maxHeight: '100%' }} /> : <img src="/avatar.png" alt="avatar" style={{ width: 36 }} />}
                </div>
                <div style={{ marginLeft: 8 }}>
                  <input type="file" accept="image/png,image/jpeg" onChange={handleAvatarChange} />
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
  );
}
